import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { forwardRef, cloneElement } from "react";
import { isElement } from "./auth-service-tools175.js";
import { createEventHandler } from "./auth-service-tools186.js";
import { useProps } from "./auth-service-tools225.js";
import { Popover } from "./auth-service-tools264.js";
import { useMenuContext } from "./auth-service-tools376.js";
const defaultProps = {
  refProp: "ref"
};
const MenuTarget = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    children,
    refProp,
    ...others
  } = useProps("MenuTarget", defaultProps, props);

  if (!isElement(children)) {
    throw new Error("Menu.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
  }

  const ctx = useMenuContext();
  const onClick = createEventHandler(children.props.onClick, () => {
    if (ctx.trigger === "click") {
      ctx.toggleDropdown();
    } else if (ctx.trigger === "click-hover") {
      ctx.setOpenedViaClick(true);

      if (!ctx.opened) {
        ctx.openDropdown();
      }
    }
  });
  const onMouseEnter = createEventHandler(children.props.onMouseEnter, () => (ctx.trigger === "hover" || ctx.trigger === "click-hover") && ctx.openDropdown());
  const onMouseLeave = createEventHandler(children.props.onMouseLeave, () => {
    if (ctx.trigger === "hover") {
      ctx.closeDropdown();
    } else if (ctx.trigger === "click-hover" && !ctx.openedViaClick) {
      ctx.closeDropdown();
    }
  });
  return /* @__PURE__ */jsxRuntimeExports.jsx(Popover.Target, {
    refProp,
    popupType: "menu",
    ref,
    ...others,
    children: /*#__PURE__*/cloneElement(children, {
      onClick,
      onMouseEnter,
      onMouseLeave,
      "data-expanded": ctx.opened ? true : void 0
    })
  });
});
MenuTarget.displayName = "@mantine/core/MenuTarget";
export { MenuTarget };